import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';

const ARROW_CLASS =
  'flex size-10 items-center justify-center rounded-full border border-foreground/15 transition-colors hover:bg-muted disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

interface HomeBestsellersControlsProps {
  /** 넘길 수 있는 묶음 수(한 화면에 보이는 카드 묶음 단위). */
  readonly pageCount: number;
  readonly pageIndex: number;
  readonly canPrev: boolean;
  readonly canNext: boolean;
  readonly onPrev: () => void;
  readonly onNext: () => void;
}

/**
 * 추천 상품 슬라이드 조작 — 가운데 얇은 진행 막대(지금 묶음의 칸만 칠함), 오른쪽 이전·다음.
 * 이전·다음은 끌기를 못 하는 키보드·단일 포인터 사용자도 넘길 수 있게 한다(WCAG 2.5.7).
 */
export const HomeBestsellersControls = ({
  pageCount,
  pageIndex,
  canPrev,
  canNext,
  onPrev,
  onNext,
}: HomeBestsellersControlsProps): ReactElement => (
  <div className="mt-10 flex items-center justify-center gap-6 sm:mt-12">
    <div aria-hidden className="h-0.5 w-40 bg-foreground/10 sm:w-64">
      <div
        className="h-full bg-foreground transition-[margin] duration-500 ease-out motion-reduce:transition-none"
        style={{
          width: `${100 / pageCount}%`,
          marginLeft: `${(100 / pageCount) * pageIndex}%`,
        }}
      />
    </div>
    <div className="flex gap-2">
      <button
        type="button"
        onClick={onPrev}
        disabled={!canPrev}
        aria-label="이전 추천 상품"
        className={ARROW_CLASS}
      >
        <ChevronLeft aria-hidden className="size-4" />
      </button>
      <button
        type="button"
        onClick={onNext}
        disabled={!canNext}
        aria-label="다음 추천 상품"
        className={ARROW_CLASS}
      >
        <ChevronRight aria-hidden className="size-4" />
      </button>
    </div>
  </div>
);
